class UserExternalIds {
  crm: string;
  ivr: string;

  constructor() {
    this.crm = "";
    this.ivr = "";
  }
}

export class User {
  id: string;
  centerId: string;
  email: string;
  externalIds: UserExternalIds;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  username: string;
  isAdmin: boolean;

  constructor() {
    this.id = "";
    this.centerId = "";
    this.email = "";
    this.externalIds = new UserExternalIds();
    this.firstName = "";
    this.lastName = "";
    this.phoneNumber = "";
    this.username = "";
    this.isAdmin = false;
  }
}

export interface IvrUser extends User {
  ivrTeamName: string;
}
